/**
 * Диалог: полный набор мета-правил поля (card_field_rules).
 */

import { cardTemplatesApi } from "@/services/card-api.service";
import { CardTemplateMetaRulesEditor } from "@/components/admin/CardTemplateMetaRulesEditor";

export interface CardTemplateFieldRulesEditorProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  templateId: number;
  fieldId: number;
  fieldLabel: string;
  canEdit: boolean;
  onSaved?: () => void;
}

export function CardTemplateFieldRulesEditor({
  templateId,
  fieldId,
  fieldLabel,
  ...rest
}: CardTemplateFieldRulesEditorProps) {
  return (
    <CardTemplateMetaRulesEditor
      {...rest}
      templateId={templateId}
      resourceId={fieldId}
      resourceLabel={fieldLabel}
      appliesTo="field"
      queryKeySuffix="field-rules"
      title="Правила поля"
      description={
        "Строки templates.card_field_rules. После сохранения обновляются колонки поля шаблона (legacy) " +
        "для согласованности с API карточки."
      }
      emptyHint="Нет правил — поле получит значения по умолчанию из обратной синхронизации."
      fetchRules={() => cardTemplatesApi.getFieldRules(templateId, fieldId)}
      putRules={(body) => cardTemplatesApi.putFieldRules(templateId, fieldId, body)}
    />
  );
}
